import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';

// Layouts
import PublicLayout from './components/layout/PublicLayout';
import DashboardLayout from './components/layout/DashboardLayout';

// Public Pages
import HomePage from './pages/public/HomePage';
import AboutPage from './pages/public/AboutPage';
import PricingPage from './pages/public/PricingPage';
import LoginPage from './pages/public/LoginPage';
import SignupPage from './pages/public/SignupPage';
import PrivacyPage from './pages/public/PrivacyPage';
import CookiePolicyPage from './pages/public/CookiePolicyPage';
import TermsPage from './pages/public/TermsPage';
import SecurityPage from './pages/public/SecurityPage';
import ResponsibleDisclosurePage from './pages/public/ResponsibleDisclosurePage';
import TrustCompliancePage from './pages/public/TrustCompliancePage';
import ForgotPasswordPage from './pages/public/ForgotPasswordPage';
import ResetPasswordPage from './pages/public/ResetPasswordPage';
import VerifyEmailPage from './pages/public/VerifyEmailPage';

// Dashboard Pages
import DashboardPage from './pages/dashboard/DashboardPage';
import ConnectPage from './pages/dashboard/ConnectPage';
import PlansPage from './pages/dashboard/PlansPage';
import SettingsPage from './pages/dashboard/SettingsPage';
import MFAStatusPage from './pages/dashboard/MFAStatusPage';
import DeviceInventoryPage from './pages/dashboard/DeviceInventoryPage';
import SecurityAlertsPage from './pages/dashboard/SecurityAlertsPage';
import FileSharingPage from './pages/dashboard/FileSharingPage';
import BillingPage from './pages/dashboard/BillingPage';
import TeamPage from './pages/dashboard/TeamPage';
import RemediationPage from './pages/dashboard/RemediationPage';
import TasksPage from './pages/dashboard/TasksPage';
import EvidencePage from './pages/dashboard/EvidencePage';
import NotificationsPage from './pages/dashboard/NotificationsPage';
import ApiKeysPage from './pages/dashboard/ApiKeysPage';
import BrandingPage from './pages/dashboard/BrandingPage';
import MSPPage from './pages/dashboard/MSPPage';

// Invitation Page
import AcceptInvitePage from './pages/AcceptInvitePage';

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/cookie-policy" element={<CookiePolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/security" element={<SecurityPage />} />
              <Route path="/responsible-disclosure" element={<ResponsibleDisclosurePage />} />
              <Route path="/trust" element={<TrustCompliancePage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
              <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
            </Route>

            {/* Invitation Accept Page (standalone) */}
            <Route path="/invite/:token" element={<AcceptInvitePage />} />

            {/* Protected Dashboard Routes */}
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<DashboardPage />} />
              <Route path="mfa" element={<MFAStatusPage />} />
              <Route path="devices" element={<DeviceInventoryPage />} />
              <Route path="security" element={<SecurityAlertsPage />} />
              <Route path="file-sharing" element={<FileSharingPage />} />
              <Route path="connect" element={<ConnectPage />} />
              <Route path="team" element={<TeamPage />} />
              <Route path="remediation" element={<RemediationPage />} />
              <Route path="tasks" element={<TasksPage />} />
              <Route path="evidence" element={<EvidencePage />} />
              <Route path="notifications" element={<NotificationsPage />} />
              <Route path="plans" element={<PlansPage />} />
              <Route path="billing" element={<BillingPage />} />
              <Route path="api-keys" element={<ApiKeysPage />} />
              <Route path="branding" element={<BrandingPage />} />
              <Route path="msp" element={<MSPPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
          </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
